import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyAc_t22UfeQPLxRALKyJN_u6zAKDdQzwH0",
  authDomain: "andromeda-stream.firebaseapp.com",
  projectId: "andromeda-stream",
  storageBucket: "andromeda-stream.appspot.com",
  messagingSenderId: "1071894626857",
  appId: "1:1071894626857:web:95c4d0b6864c12dc8a5238",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const auth = firebaseApp.auth();
export const provider = new firebase.auth.GoogleAuthProvider();

export default auth;
